import React from 'react'
import styled from 'styled-components'
import { Button } from '~common/components/button'
import { useAppContext } from '~/app-context'
import { useTheme } from '~common/theme/theme-provider'
import { SvgRenderer } from '~common/components/svg-renderer'

interface Props {
    onClose: () => void
    offerId?: string
}

export default function TwentyFiveLeftNotif({ onClose, offerId }: Props) {
    const { services } = useAppContext()
    const { isDark } = useTheme()

    const handleUpgrade = () => {
        services.globalEvents.emit({
            type: 'openModal',
            modalType: 'pricing',
        })
    }

    const image = isDark
        ? '/assets/images/last-docs-dm.svg'
        : '/assets/images/last-docs.svg'

    return (
        <Container>
            <SvgRenderer
                src={image}
                alt="Out of free invoices"
                height="250px"
                width="250px"
            />
            <Title>You're low on invoice credits</Title>
            <Subtitle>
                We've stopped automatic import so you still can search and
                import individual emails.
            </Subtitle>
            <Buttons>
                <Button
                    onClick={handleUpgrade}
                    variant="primary"
                    size="large"
                    label="Upgrade Now"
                />
                <Button
                    onClick={onClose}
                    variant="outline"
                    size="large"
                    label="Maybe Later"
                />
            </Buttons>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: ${({ theme }) => theme.spacing[6]};
    padding: ${({ theme }) => theme.spacing[6]};
    height: 100%;
`

const Image = styled.img`
    width: 120px;
    height: 120px;
    opacity: 0.8;
`

const Title = styled.h2`
    font-size: ${({ theme }) => theme.typography.fontSize['2xl']};
    font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
    color: ${({ theme }) => theme.colors.text.primary};
    margin: 0;
`

const Subtitle = styled.p`
    font-size: ${({ theme }) => theme.typography.fontSize.base};
    color: ${({ theme }) => theme.colors.text.secondary};
    max-width: 400px;
    line-height: 1.6;
    margin: 0;
    margin-top: -${({ theme }) => theme.spacing[2]};
`

const Buttons = styled.div`
    display: flex;
    gap: ${({ theme }) => theme.spacing[4]};
    justify-content: center;
    width: 100%;
    margin-top: ${({ theme }) => theme.spacing[4]};
`
